module.exports = __webpack_public_path__ + "img/droplet-slash.843ab175.svg";